import {
  Group,
  Container,
  Grid,
  TextInput,
  Button,
  Alert,
  Stack,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useLocation } from "wouter";
import { createUser, sendUserInvitation } from "../api";
import { notifications } from "@mantine/notifications";

export default function UserAdd() {
  const [, setLocation] = useLocation();

  const addUserHandler = (data) => {
    createUser(data).then((response) => {
      notifications.show({
        color: "green",
        autoClose: 3000,
        title: "User created!",
      });
      sendUserInvitation(response.id).then(() => {
        notifications.show({
          color: "green",
          autoClose: 3000,
          title: "Invitation sent!",
        });
      });
      setLocation("/users");
    });
  };

  const form = useForm({
    mode: "uncontrolled",
    validate: {
      emailAddress: (val) => (/^\S+@\S+$/.test(val) ? null : "Invalid email"),
    },
  });

  return (
    <Container size="xs" px={0}>
      <Alert mb="md">
        This will send an invitation to the user so they can join you to
        collaborate. Users can choose to login via a different login than email,
        but an email is required for the invitation.
      </Alert>
      <Grid justify="space-between">
        <Grid.Col span={12}>
          <form onSubmit={form.onSubmit(addUserHandler)}>
            <Stack>
              <TextInput
                {...form.getInputProps("emailAddress")}
                key={form.key("emailAddress")}
                label="Email"
                withAsterisk
              />

              <TextInput
                {...form.getInputProps("firstName")}
                key={form.key("firstName")}
                label="First Name"
              />

              <TextInput
                {...form.getInputProps("lastName")}
                key={form.key("lastName")}
                label="Last Name"
              />

              <Group justify="flex-end">
                <Button type="submit" mt="md">
                  Invite user
                </Button>
              </Group>
            </Stack>
          </form>
        </Grid.Col>
      </Grid>
    </Container>
  );
}
